import React from "react";

// Poppins served from our own origin, not fonts.googleapis.com: every
// visitor's IP went to Google (docs/rgpd.md). The same weights as before;
// latin and latin-ext cover French and English.
import "@fontsource/poppins/latin-100.css";
import "@fontsource/poppins/latin-300.css";
import "@fontsource/poppins/latin-400.css";
import "@fontsource/poppins/latin-ext-100.css";
import "@fontsource/poppins/latin-ext-300.css";
import "@fontsource/poppins/latin-ext-400.css";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import "./i18n/i18n";
import "./styles/index.css";

const root = ReactDOM.createRoot(
	document.getElementById("root") ?? document.createElement("div")
);

root.render(<App />);
